import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import NextMoveCard from ".";
import Translate from "translate/Translate";
import { useNextMoveMemberContext } from "./useNextMoveMemberContext";

const ReactivateAccountNextMoveCard = () => {
  const history = useHistory();
  const { isMemberActive } = useNextMoveMemberContext();

  const onActionClick = useCallback(() => {
    trackDashboardCtaClicked({
      workflow: "account",
      ctaLocation: "next_move_card",
      ctaId: "inactive_member"
    });
    history.push(PATHS.ACCOUNT_MANAGEMENT_PAYMENT_INFORMATION);
  }, [history]);

  if (isMemberActive) {
    return null;
  }

  return (
    <NextMoveCard
      id="reactivate-account-next-move"
      tag="important"
      title={<Translate text="Reactivate your account" />}
      body={
        <Translate text="Your membership has expired. Fortunately, reactivating is easy. Simply click here to reinstate access to everything Genomic Life has to offer." />
      }
      link={{
        onClick: onActionClick,
        overrideClick: true,
        text: "Reactivate today",
        url: PATHS.ACCOUNT_MANAGEMENT_PAYMENT_INFORMATION
      }}
    />
  );
};

export default ReactivateAccountNextMoveCard;
